import { AnyAction } from 'redux';
import { SET_SELECTED_SECTION, SET_SELECTED_SIDEBAR_TAB } from '../types/types';

const initialState = {
	selectedTab: 'dashboard',
	selectedSection: 'Documents'
};

export default function sideBarReducer(
	state = initialState,
	action: AnyAction
) {
	switch (action.type) {
		case SET_SELECTED_SIDEBAR_TAB:
			return {
				...state,
				selectedTab: action.selectedTab
			};
		case SET_SELECTED_SECTION:
			return {
				...state,
				selectedSection: action.selectedSection
			};
		default:
			return state;
	}
}
